import React from "react";
import { useFormContext } from "react-hook-form";

import OptionallyDisplayed from "./optionallyDisplayed";
import ErrorMessage from "./errorMessage";
import TextViewHook from "./textViewHook";
import { metaDefault } from "../../config/meta";
import LoadingAnim from "./loadingAnim";

export default function RedemptionForm({
  onSubmit,
  submitErrors,
  validationRules,
  isLoading,
  loadMessage,
  redeemCta,
  redeemLabel,
  placeholder,
  buttonText,
  title,
}) {
  const { handleSubmit, formState } = useFormContext();

  const renderContent = () => {
    if (isLoading) {
      return (
        <LoadingAnim>
          <p className="redemption-load-text">{loadMessage}</p>
        </LoadingAnim>
      );
    }

    return (
      <div className="container redeem-code-container">
        <h2 className="redeem-cta">{redeemCta}</h2>

        <OptionallyDisplayed doDisplay={!!submitErrors}>
          <ErrorMessage error={submitErrors} />
        </OptionallyDisplayed>

        <form className="redeem-form" onSubmit={handleSubmit(onSubmit)}>
          <TextViewHook
            className="code-input"
            rules={validationRules}
            name="code"
            label={redeemLabel}
            placeholder={placeholder}
            errors={{}}
          />

          <div className="redeem-button">
            <button type="submit" disabled={!formState.isValid} className="button-flat-color">
              {buttonText}
            </button>
          </div>
        </form>
      </div>
    );
  };

  return (
    <>
      <div className="redeem">
        <div className="no-background">
          <div className="container">
            <h1 className="home-free-games-title">{title}</h1>
          </div>
        </div>

        <div className="wrapper padded no-background">{renderContent()}</div>
      </div>
    </>
  );
}
